import { useIntl, FormatNumberOptions } from 'react-intl'

type Props = {
  value: number
  options?: FormatNumberOptions
}

const NumberCell: React.FC<Props> = ({value, options}) => {
  const intl = useIntl()

  return (
    <>
      {options ? (
        <>{intl.formatNumber(value, options)}</>
      ) : (
        <>{intl.formatNumber(value)}</>
      )}
    </>
  )
}

export {NumberCell}
